<template>
  <div id="app" @click="closeLogin">
    <HeaderVue
      ref="header"
      @openLogin="openLogin"
      @openRegister="openRegister"
      @openMessageBox="openMessageBox"
      :login="login"
      :loginData="loginData"
      @loginOut="loginOut"
      @openUserInfo="openUserInfo"
    ></HeaderVue>
    <div class="content">
      <router-view
        @openMessageBoxWrap="openMessageBoxWrap2"
        @openMessageBox="openMessageBoxWrap"
        @goLogin="goLogin"
        @changeUserInfo="changeUserInfo"
        @loginOut="loginOut"
        :loginData="loginData"
        @openLogin="openLogin"
        @openRegister="openRegister"
        :login="login"
      />
    </div>
    <!-- <FooterVue  @loginOut="loginOut" :loginData="loginData" @openLogin="openLogin" @openRegister="openRegister" :login="login"></FooterVue> -->
    <!-- 登录 -->
    <transition name="fade">
      <LoginVue
        v-if="loginFlag"
        :serviceList="serviceList"
        @openRegister="openRegister"
        @loginInto="loginSubmit"
        @restPassword="restPassword"
        @openMessageBoxWrap="openMessageBoxWrap2"
      ></LoginVue>
    </transition>
    <!-- 忘记密码 -->
    <transition name="fade">
      <RestPasswordVue
        v-if="restPasswordFlag"
        @closeRestPassword="closeRestPassword"
      ></RestPasswordVue>
    </transition>
    <!-- 注册 -->
    <transition name="fade">
      <RegisterVue
        v-if="registerFlag"
        :serviceList="serviceList"
        @closeRegisterVue="closeRegisterVue"
        @openMessageBoxWrap="openMessageBoxWrap2"
      ></RegisterVue>
    </transition>
    <!-- 消息列表 -->
    <MessageVue
      v-if="login"
      :messageFlag="messageFlag"
      @openMessageBox="openMessageBoxWrap"
    ></MessageVue>
    <!-- 消息详情 -->
    <MessageBoxVue
      v-if="MessageBoxVueFlag"
      :messageData="messageData"
      @close="closeMessageBoxVue"
    ></MessageBoxVue>
    <!-- 消息详情2 -->
    <MessageBoxVue2
      v-if="MessageBoxVueFlag2"
      :messageData="messageData2"
      @close="closeMessageBoxVue2"
    ></MessageBoxVue2>
    <!-- 浮动菜单 -->
    <FloatMenu v-if="login"></FloatMenu>
    <!-- 用户详情 -->
    <UserInfoVue
      @closeBox="closeUserInfo"
      :userInfoData="userInfoData"
      :drawer="drawer"
      @deteleUser="deteleUser"
    ></UserInfoVue>

    
  </div>
</template>
<script>
// import FooterVue from './components/Footer/Footer.vue'
import HeaderVue from "./components/Header/HeaderVue.vue";
import LoginVue from "./components/Login/LoginVue.vue";
import RegisterVue from "./components/Register/RegisterVue.vue";
import MessageVue from "./components/Message/MessageVue.vue";
import MessageBoxVue from "@/components/MessageBox/MessageBoxVue.vue";
import MessageBoxVue2 from "@/components/MessageBox/MessageBoxVue2.vue";
import FloatMenu from "@/components/Menu/MenuVue.vue";
import RestPasswordVue from "./components/RestPassword/RestPasswordVue.vue";
import UserInfoVue from "@/components/UserInfo/UserInfoVue.vue";
import notice from "@/api/notice";
export default {
  name: "App",
  components: {
    HeaderVue,
    // FooterVue,
    LoginVue,
    RegisterVue,
    MessageVue,
    MessageBoxVue,
    FloatMenu,
    RestPasswordVue,
    UserInfoVue,
    MessageBoxVue2,
  },
  data() {
    return {
      loginFlag: false,
      registerFlag: false,
      messageFlag: false,
      MessageBoxVueFlag: false,
      MessageBoxVueFlag2: false,
      loginData: {},
      messageData: {},
      messageData2: {},
      login: false,
      restPasswordFlag: false,
      drawer: false,
      userInfoData: {},
      serviceList: [],
      dialogFormVisible: true,
      deleteEmail: '',
      deleteUserCode: ''
    };
  },
  methods: {
    deteleUser(email) {
      
      this.deleteEmail = email
      this.dialogFormVisible = true;
    },
    openUserInfo(data) {
      this.userInfoData = data;
      this.drawer = true;
    },
    closeUserInfo(type) {
      this.drawer = false;
      if(type === 'delUser') {
        this.$refs.header.doLoginOut("请重新登录");
      }
    },
    changeUserInfo() {
      this.$refs.header.UPDATE_NAME();
    },
    closeRestPassword() {
      this.restPasswordFlag = false;
      this.loginFlag = true;
    },
    restPassword() {
      this.restPasswordFlag = true;
      this.loginFlag = false;
    },
    loginSubmit(data) {
      this.loginData = data;
      this.loginFlag = false;
      this.login = true;
    },
    openLogin() {
      this.registerFlag = false;
      this.loginFlag = true;
    },
    closeLogin(event) {
      if (
        (!event.target.closest(".LoginVue-wrap") &&
          !event.target.closest(".button") &&
          !event.target.closest(".register-button") &&
          !event.target.closest(".RegisterVue-wrap") &&
          !event.target.closest(".MessageVueWrap") &&
          !event.target.closest(".el-icon-message-solid") &&
          !event.target.closest(".MessageBoxVueWrap") &&
          !event.target.closest(".foot-login") &&
          !event.target.closest(".foot-register") &&
          !event.target.closest(".search-button") &&
          !event.target.closest(".search-box") &&
          !event.target.closest(".click-in-button")) ||
        event.target.closest(".el-icon-s-custom")
      ) {
        if (this.registerFlag) {
          this.registerFlag = false;
        } else {
          this.loginFlag = false;
        }
      }
      if (
        !event.target.closest(".button") &&
        !event.target.closest(".MessageVueWrap") &&
        !event.target.closest(".MessageBoxVueWrap")
      ) {
        this.messageFlag = false;
      }
    },
    openRegister() {
      this.registerFlag = true;
    },
    closeRegisterVue() {
      this.registerFlag = false;
    },
    openMessageBox() {
      this.messageFlag = !this.messageFlag;
    },
    openMessageBoxWrap(data) {
      this.MessageBoxVueFlag = true;
      this.messageData = data;
    },
    openMessageBoxWrap2(data) {
      // this.MessageBoxVueFlag2 = true;
      // this.messageData2 = data;
      let routeData = this.$router.resolve({
        path: "/termsofservice?id=" + data.id,
      });
      window.open(routeData.href, "_blank");
    },
    closeMessageBoxVue() {
      this.MessageBoxVueFlag = false;
    },
    closeMessageBoxVue2() {
      this.MessageBoxVueFlag2 = false;
    },
    goLogin() {
      this.loginFlag = true;
    },
    getMessageCount() {
      this.$refs.header.getMessageCount();
    },
    loginOut() {
      this.login = false;
    },
    getServiceList() {
      notice.openwebtermsofserviceList().then((res) => {
        if (res.code === 0) {
          this.serviceList = res.data;
          console.log(this.serviceList);
        }
      });
    },
  },
  provide() {
    return {
      getVueMessageCount: this.getMessageCount,
    };
  },
  created() {
    this.login = Boolean(sessionStorage.getItem("login") === "true");
    this.getServiceList();
  },
};
</script>
<style lang="scss">
@import url("@/assets/css/style.scss");
</style>
